import * as React from 'react'
import {
  EditButton,
  DeleteButton,
  CreateButton,
  useShowContext,
  ShowBase,
  TabbedShowLayout,
  Tab,
} from 'react-admin'
import { Box, Container, Typography, Icon, Button, Grid } from '@mui/material'

import { CardCommon } from 'src/components/uiElements/cards/CardCommon'
import { Link } from 'react-router-dom'

export const AirDetailShow = (props) => {
  const AirDetailShowContent = (props) => {
    const { record, loaded } = useShowContext()

    if (!loaded || !record) return null
    return (
      <>
        <Box className='app_page_header' mb={4}>
          <Container>
            <div className='app_page_header_content'>
              <Box display='flex'>
                <Box flex='1'>
                  <Button
                    color='inherit'
                    component={Link}
                    startIcon={<Icon>arrow_back</Icon>}
                    to={props.basePath}
                    value={props.basePath}
                  >
                    {' '}
                    {props.resource}{' '}
                  </Button>
                  <Typography variant='h3'>{record.short_name}</Typography>
                </Box>
                <Box>
                  <EditButton basePath={props.basePath} className='ml-3' />
                  <CreateButton basePath={props.basePath} className='ml-3' />
                  <DeleteButton basePath={props.basePath} />
                </Box>
              </Box>
            </div>
          </Container>
        </Box>

        <Container>
          <TabbedShowLayout className='tabbed_show_layout'>
            <Tab label='Datos Generales'>
              <Box display='flex'>
                <Box flex='1'>
                  <CardCommon /* title={'Datos generales'} actions={''} */>
                    <>
                      <Grid container>
                        <Grid item md={4}>
                          <Typography variant='subtitle2'>Id</Typography>
                          <Typography variant='body2' className='mb-6'>
                            {record.id}
                          </Typography>
                        </Grid>
                        <Grid item md={4}>
                          <Typography variant='subtitle2'>airline</Typography>
                          <Typography variant='body2' className='mb-6'>
                            {record.airline}
                          </Typography>
                        </Grid>
                        <Grid item md={4}>
                          <Typography variant='subtitle2'>date in</Typography>
                          <Typography variant='body2' className='mb-6'>
                            {record.date_in}
                          </Typography>
                        </Grid>
                        <Grid item md={4}>
                          <Typography variant='subtitle2'>date out</Typography>
                          <Typography variant='body2' className='mb-6'>
                            {record.date_out}
                          </Typography>
                        </Grid>
                        <Grid item md={4}>
                          <Typography variant='subtitle2'>item id</Typography>
                          <Typography variant='body2' className='mb-6'>
                            {record.item_id}
                          </Typography>
                        </Grid>
                      </Grid>
                    </>
                  </CardCommon>
                </Box>
                <Box ml={4} width={350} minWidth={350}>
                  <CardCommon title={'Title here'} actions={''}>
                    Other content
                  </CardCommon>
                </Box>
              </Box>
            </Tab>

            <Tab label='Condiciones comerciales' path='conditions'>
              <Typography variant='subtitle2'>Condiciones comerciales</Typography>
            </Tab>

            <Tab label='Configuración' path='setup'>
              <Typography variant='subtitle2'>Configuración</Typography>
            </Tab>
          </TabbedShowLayout>
        </Container>
      </>
    )
  }

  return (
    <>
      {/*  <Show {...props}>
            <SimpleShowLayout>
            <TextField source='id' label="Id" />
            <TextField source='username' label="Username" />
            <TextField source='first_name' />
            <Typography variant="h6" gutterBottom> General </Typography>
            <TextField source='last_name' />
              <Typography variant="h6" gutterBottom>
                  Contacto
              </Typography>
              <EmailField source='email' /> 
              <EditButton basePath='/users' />
                <DeleteButton basePath='/users' />
                  
            </SimpleShowLayout>
        </Show> */}

      <ShowBase {...props}>
        <AirDetailShowContent {...props} />
      </ShowBase>
    </>
  )
}
